// Kimiya product page interactions.
//
// The design mockup's script with the demo-only parts removed — no SVG bottle
// generator, no fake bag counter, no invented review filters — and the size
// buttons wired to real Shopify variants instead of hard-coded prices.

(function () {
  'use strict';

  var root = document.querySelector('.kim-pdp');
  if (!root) return;

  var sizes = document.getElementById('sizes');
  var priceEl = document.getElementById('price');
  var unitEl = document.getElementById('unit');
  var addPrice = document.getElementById('addPrice');
  var skuEl = document.getElementById('skuVal');
  var sizeName = document.getElementById('sizeName');
  var qtyEl = document.getElementById('qty');
  var idInput = document.getElementById('kimVariantId');
  var addBtn = document.getElementById('addBtn');

  // The sticky buy bar. Every one of these can legitimately be absent: the
  // bar is not rendered for a sold-out product, and it carries no size control
  // when the product has a single variant.
  var bar = document.querySelector('[data-kim-buy-bar]');
  var barSize = bar && bar.querySelector('[data-kim-buy-bar-size]');
  var barQty = bar && bar.querySelector('[data-kim-buy-bar-qty]');
  var barPrice = bar && bar.querySelector('[data-kim-buy-bar-price]');
  var barLabel = bar && bar.querySelector('[data-kim-buy-bar-label]');

  // At 360px the select, the stepper and the gaps leave about 150px for the
  // button, and "add to bag — $12.99" needs more than that: it wrapped to two
  // lines and made the bar taller than the space it exists to save. The
  // wording is chosen here rather than in CSS because ::before content cannot
  // reach the accessible name, and a second hidden span to carry it is more
  // machinery than one matchMedia.
  var narrow = window.matchMedia('(max-width: 409px)');
  function addLabel() {
    return narrow.matches ? 'add —' : 'add to bag —';
  }
  var barAdd = bar && bar.querySelector('[data-kim-buy-bar-add]');

  function money(n) {
    return '$' + n.toFixed(2);
  }

  // The unit line divides price by the quantity in the variant title, e.g.
  // "4 fl oz" -> 4. A title with no leading number simply gets no unit line.
  function unitFor(price, name) {
    var m = (name || '').match(/([\d.]+)\s*(fl\s*oz|oz|ml|lb|g)/i);
    if (!m) return '';
    var qty = parseFloat(m[1]);
    if (!qty) return '';
    return money(price / qty) + ' / ' + m[2].toLowerCase().replace(/\s+/g, ' ');
  }

  function selected() {
    return sizes ? sizes.querySelector('.size[aria-pressed="true"]') : null;
  }

  function render() {
    var q = Math.max(1, parseInt(qtyEl && qtyEl.value, 10) || 1);
    var b = selected();

    // Single-variant products have no size buttons; only the quantity maths
    // applies, and the price element already holds the server-rendered price.
    if (!b) {
      if (priceEl) {
        var base = parseFloat(priceEl.textContent.replace(/[^0-9.]/g, '')) || 0;
        if (addPrice) addPrice.textContent = money(base * q);
        if (barPrice) barPrice.textContent = money(base * q);
      }
      if (barQty && barQty.value !== String(q)) barQty.value = q;
      if (barLabel) barLabel.textContent = addLabel();
      return;
    }

    var price = parseFloat(b.getAttribute('data-price')) || 0;
    var name = b.getAttribute('data-name') || '';

    if (priceEl) priceEl.textContent = money(price);
    if (unitEl) unitEl.textContent = unitFor(price, name);
    if (addPrice) addPrice.textContent = money(price * q);
    if (skuEl) skuEl.textContent = b.getAttribute('data-sku') || '';
    if (sizeName) sizeName.textContent = name;
    if (idInput) idInput.value = b.getAttribute('data-id');

    var soldOut = b.getAttribute('data-available') !== 'true';
    if (addBtn) addBtn.disabled = soldOut;

    // The bar is a view of the same state, written from the same place. It is
    // never the source of a price or a variant id, only a reflection of one.
    if (barAdd) barAdd.disabled = soldOut;
    if (barLabel) barLabel.textContent = soldOut ? 'sold out' : addLabel();
    if (barPrice) {
      barPrice.textContent = soldOut ? '' : money(price * q);
      barPrice.hidden = soldOut;
    }
    if (barSize && barSize.value !== b.getAttribute('data-id')) {
      barSize.value = b.getAttribute('data-id');
    }
    if (barQty && barQty.value !== String(q)) barQty.value = q;
  }

  if (sizes) {
    sizes.addEventListener('click', function (e) {
      var b = e.target.closest('.size');
      if (!b) return;
      Array.prototype.forEach.call(sizes.children, function (c) {
        c.setAttribute('aria-pressed', 'false');
      });
      b.setAttribute('aria-pressed', 'true');
      render();
    });
  }

  var plus = document.getElementById('plus');
  var minus = document.getElementById('minus');
  if (plus) {
    plus.addEventListener('click', function () {
      qtyEl.value = (parseInt(qtyEl.value, 10) || 1) + 1;
      render();
    });
  }
  if (minus) {
    minus.addEventListener('click', function () {
      qtyEl.value = Math.max(1, (parseInt(qtyEl.value, 10) || 1) - 1);
      render();
    });
  }
  if (qtyEl) qtyEl.addEventListener('input', render);

  // ---- sticky buy bar ----------------------------------------------------
  //
  // Three controls, none of which owns any state. Each one writes into the
  // buy box and lets render() push the result back out to both surfaces.
  if (bar) {
    // Rotating a phone crosses that width threshold, so the label is chosen
    // again rather than left at whatever it was when the page loaded.
    if (narrow.addEventListener) narrow.addEventListener('change', render);

    // The size select drives the real size button rather than the hidden
    // variant input, so everything the click handler does — price, unit
    // price, SKU, stock, the pressed state on the card the customer will see
    // when they scroll back up — happens exactly as if they had tapped it.
    if (barSize && sizes) {
      barSize.addEventListener('change', function () {
        var target = sizes.querySelector('.size[data-id="' + barSize.value + '"]');
        if (target) target.click();
      });
    }

    bar.addEventListener('click', function (event) {
      var step = event.target.closest('[data-kim-buy-bar-step]');
      if (!step || !qtyEl) return;
      var next = (parseInt(qtyEl.value, 10) || 1) + parseInt(step.getAttribute('data-kim-buy-bar-step'), 10);
      qtyEl.value = Math.max(1, next);
      render();
    });

    if (barQty && qtyEl) {
      barQty.addEventListener('input', function () {
        qtyEl.value = Math.max(1, parseInt(barQty.value, 10) || 1);
        render();
      });
    }

    // requestSubmit with the real button as the submitter, so the listener in
    // kimiya-shop.js sees event.submitter === #addBtn and upgrades this to the
    // AJAX add that opens the drawer. A plain .submit() would skip validation
    // and every submit listener, and navigate to /cart.
    if (barAdd) {
      barAdd.addEventListener('click', function () {
        var form = document.getElementById('kimBuy');
        if (!form || !addBtn || addBtn.disabled) return;
        if (form.requestSubmit) form.requestSubmit(addBtn);
        else addBtn.click();
      });
    }

    // Visible only while the real button is off screen. An observer rather
    // than a scroll handler: the browser reports the crossing itself, off the
    // main thread, instead of this asking for a rectangle on every frame.
    var showBar = function (show) {
      bar.hidden = !show;
      // inert keeps the duplicate controls out of the tab order while the bar
      // is down; hidden alone would do it, but the two are set together so a
      // future transition can drop `hidden` without opening a keyboard trap.
      if (show) bar.removeAttribute('inert');
      else bar.setAttribute('inert', '');
    };

    var watch = document.querySelector('.qty-add') || addBtn;
    if (watch && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        showBar(!entries[0].isIntersecting);
      }, {
        // A little slack at the bottom: without it the bar reappears while
        // the real button is still a few pixels on screen, and the two sit
        // stacked for a moment.
        rootMargin: '0px 0px -80px 0px'
      }).observe(watch);
    } else {
      // No observer: better to have the bar always than never.
      showBar(true);
    }

    // The drawer slides in over the bottom-right of the screen. Two stacked
    // "add to bag" affordances, one of them behind a panel, is not a choice
    // anyone needs to be offered.
    if ('MutationObserver' in window) {
      new MutationObserver(function () {
        bar.classList.toggle('is-suppressed', document.body.classList.contains('kim-cart-open'));
      }).observe(document.body, { attributes: true, attributeFilter: ['class'] });
    }
  }

  // ---- foldable sections -------------------------------------------------
  //
  // The three reference sections ship with `open` set, so with no JavaScript
  // the page reads as it always did and desktop needs no work at all. This
  // closes them below 750px, reopens them if the viewport grows past it, and
  // keeps one open at a time while they are collapsible.
  var folds = document.querySelectorAll('[data-kim-fold]');
  if (folds.length) {
    var foldNarrow = window.matchMedia('(max-width: 749px)');

    var applyFolds = function () {
      Array.prototype.forEach.call(folds, function (fold) {
        if (foldNarrow.matches) fold.removeAttribute('open');
        else fold.setAttribute('open', '');
      });
    };
    applyFolds();
    if (foldNarrow.addEventListener) foldNarrow.addEventListener('change', applyFolds);

    // One at a time: opening a section closes whichever was open, so the row
    // you tapped stays under your thumb instead of being pushed down the page
    // by a section still expanded above it.
    //
    // The guard matters. Closing the others fires their own toggle events, and
    // without it each one would re-enter this handler while the first is still
    // running. It is also skipped above 750px, where every section is meant to
    // be open at once.
    var closing = false;
    Array.prototype.forEach.call(folds, function (fold) {
      fold.addEventListener('toggle', function () {
        if (closing || !fold.open || !foldNarrow.matches) return;
        closing = true;
        Array.prototype.forEach.call(folds, function (other) {
          if (other !== fold) other.removeAttribute('open');
        });
        closing = false;
      });
    });
  }

  // Gallery: swap the stage image, matching the design's thumb behaviour.
  var thumbs = document.getElementById('thumbs');
  var stage = document.getElementById('stageImg');
  if (thumbs && stage) {
    thumbs.addEventListener('click', function (e) {
      var b = e.target.closest('.thumb');
      if (!b) return;
      stage.src = b.getAttribute('data-full');
      Array.prototype.forEach.call(thumbs.children, function (c) {
        c.setAttribute('aria-current', 'false');
      });
      b.setAttribute('aria-current', 'true');
    });
  }

  // The badge collapse/"+n more" behaviour is gone: badges now render as one
  // line of plain text with nothing to expand, per the Oct 2026 notes.

  // Header behaviour moved to kimiya-chrome.js — this file only loads on a
  // product page, and the header renders on every template.

  render();
})();
